export { default } from './ErrorHandlingLayout';
